var map = {
	"./AbandonedCarts": [
		97039,
		[
			39
		]
	],
	"./AbandonedCarts/": [
		97039,
		[
			39
		]
	],
	"./AbandonedCarts/index": [
		97039,
		[
			39
		]
	],
	"./AbandonedCarts/index.jsx": [
		97039,
		[
			39
		]
	],
	"./AbandonedCarts/reducer": [
		28787,
		[]
	],
	"./AbandonedCarts/reducer.js": [
		28787,
		[]
	],
	"./Banners": [
		76461,
		[
			461
		]
	],
	"./Banners/": [
		76461,
		[
			461
		]
	],
	"./Banners/Create": [
		9013,
		[
			13
		]
	],
	"./Banners/Create.jsx": [
		9013,
		[
			13
		]
	],
	"./Banners/Update": [
		59106,
		[
			106
		]
	],
	"./Banners/Update.jsx": [
		59106,
		[
			106
		]
	],
	"./Banners/index": [
		76461,
		[
			461
		]
	],
	"./Banners/index.jsx": [
		76461,
		[
			461
		]
	],
	"./Banners/reducer": [
		28143,
		[]
	],
	"./Banners/reducer.js": [
		28143,
		[]
	],
	"./Brands": [
		19742,
		[
			742
		]
	],
	"./Brands/": [
		19742,
		[
			742
		]
	],
	"./Brands/Create": [
		67896,
		[
			896
		]
	],
	"./Brands/Create.jsx": [
		67896,
		[
			896
		]
	],
	"./Brands/Update": [
		11719,
		[
			719
		]
	],
	"./Brands/Update.jsx": [
		11719,
		[
			719
		]
	],
	"./Brands/index": [
		19742,
		[
			742
		]
	],
	"./Brands/index.jsx": [
		19742,
		[
			742
		]
	],
	"./Brands/reducer": [
		17006,
		[]
	],
	"./Brands/reducer.js": [
		17006,
		[]
	],
	"./Catalogs": [
		984,
		[
			984
		]
	],
	"./Catalogs/": [
		984,
		[
			984
		]
	],
	"./Catalogs/Create": [
		24570,
		[
			570
		]
	],
	"./Catalogs/Create.jsx": [
		24570,
		[
			570
		]
	],
	"./Catalogs/Update": [
		80841,
		[
			841
		]
	],
	"./Catalogs/Update.jsx": [
		80841,
		[
			841
		]
	],
	"./Catalogs/index": [
		984,
		[
			984
		]
	],
	"./Catalogs/index.jsx": [
		984,
		[
			984
		]
	],
	"./Catalogs/reducer": [
		51124,
		[]
	],
	"./Catalogs/reducer.js": [
		51124,
		[]
	],
	"./Categories": [
		97376,
		[
			376
		]
	],
	"./Categories/": [
		97376,
		[
			376
		]
	],
	"./Categories/Create": [
		83522,
		[
			522
		]
	],
	"./Categories/Create.jsx": [
		83522,
		[
			522
		]
	],
	"./Categories/Update": [
		31313,
		[
			313
		]
	],
	"./Categories/Update.jsx": [
		31313,
		[
			313
		]
	],
	"./Categories/index": [
		97376,
		[
			376
		]
	],
	"./Categories/index.jsx": [
		97376,
		[
			376
		]
	],
	"./Categories/reducer": [
		5292,
		[]
	],
	"./Categories/reducer.js": [
		5292,
		[]
	],
	"./Colors": [
		40384,
		[]
	],
	"./Colors/": [
		40384,
		[]
	],
	"./Colors/Create": [
		14626,
		[]
	],
	"./Colors/Create.jsx": [
		14626,
		[]
	],
	"./Colors/Recipe": [
		29988,
		[
			988
		]
	],
	"./Colors/Recipe.jsx": [
		29988,
		[
			988
		]
	],
	"./Colors/Update": [
		45009,
		[]
	],
	"./Colors/Update.jsx": [
		45009,
		[]
	],
	"./Colors/index": [
		40384,
		[]
	],
	"./Colors/index.jsx": [
		40384,
		[]
	],
	"./Dashboard": [
		73832,
		[]
	],
	"./Dashboard/": [
		73832,
		[]
	],
	"./Dashboard/index": [
		73832,
		[]
	],
	"./Dashboard/index.jsx": [
		73832,
		[]
	],
	"./Dashboard/reducer": [
		92772,
		[]
	],
	"./Dashboard/reducer.js": [
		92772,
		[]
	],
	"./Documentation": [
		47210,
		[]
	],
	"./Documentation/": [
		47210,
		[]
	],
	"./Documentation/index": [
		47210,
		[]
	],
	"./Documentation/index.js": [
		47210,
		[]
	],
	"./Home": [
		38009,
		[
			926
		]
	],
	"./Home/": [
		38009,
		[
			926
		]
	],
	"./Home/index": [
		38009,
		[
			926
		]
	],
	"./Home/index.jsx": [
		38009,
		[
			926
		]
	],
	"./Kanvan": [
		51545,
		[
			545
		]
	],
	"./Kanvan/": [
		51545,
		[
			545
		]
	],
	"./Kanvan/index": [
		51545,
		[
			545
		]
	],
	"./Kanvan/index.jsx": [
		51545,
		[
			545
		]
	],
	"./Login": [
		28160,
		[]
	],
	"./Login/": [
		28160,
		[]
	],
	"./Login/index": [
		28160,
		[]
	],
	"./Login/index.jsx": [
		28160,
		[]
	],
	"./OnConstruction": [
		59095,
		[
			622
		]
	],
	"./OnConstruction/": [
		59095,
		[
			622
		]
	],
	"./OnConstruction/index": [
		59095,
		[
			622
		]
	],
	"./OnConstruction/index.jsx": [
		59095,
		[
			622
		]
	],
	"./Orders": [
		66343,
		[]
	],
	"./Orders/": [
		66343,
		[]
	],
	"./Orders/Detail": [
		87436,
		[]
	],
	"./Orders/Detail.jsx": [
		87436,
		[]
	],
	"./Orders/index": [
		66343,
		[]
	],
	"./Orders/index.jsx": [
		66343,
		[]
	],
	"./Orders/reducer": [
		31293,
		[]
	],
	"./Orders/reducer.js": [
		31293,
		[]
	],
	"./Products": [
		11144,
		[
			144
		]
	],
	"./Products/": [
		11144,
		[
			144
		]
	],
	"./Products/Update": [
		70297,
		[
			297
		]
	],
	"./Products/Update.jsx": [
		70297,
		[
			297
		]
	],
	"./Products/index": [
		11144,
		[
			144
		]
	],
	"./Products/index.jsx": [
		11144,
		[
			144
		]
	],
	"./Products/reducer": [
		36004,
		[]
	],
	"./Products/reducer.js": [
		36004,
		[]
	],
	"./Subscriptions": [
		47330,
		[]
	],
	"./Subscriptions/": [
		47330,
		[]
	],
	"./Subscriptions/index": [
		47330,
		[]
	],
	"./Subscriptions/index.jsx": [
		47330,
		[]
	],
	"./Subscriptions/reducer": [
		48162,
		[]
	],
	"./Subscriptions/reducer.js": [
		48162,
		[]
	],
	"./TopProducts": [
		62345,
		[
			345
		]
	],
	"./TopProducts/": [
		62345,
		[
			345
		]
	],
	"./TopProducts/Create": [
		89337,
		[
			337
		]
	],
	"./TopProducts/Create.jsx": [
		89337,
		[
			337
		]
	],
	"./TopProducts/Update": [
		35502,
		[
			502
		]
	],
	"./TopProducts/Update.jsx": [
		35502,
		[
			502
		]
	],
	"./TopProducts/index": [
		62345,
		[
			345
		]
	],
	"./TopProducts/index.jsx": [
		62345,
		[
			345
		]
	],
	"./TopProducts/reducer": [
		18491,
		[]
	],
	"./TopProducts/reducer.js": [
		18491,
		[]
	],
	"./Users": [
		75700,
		[
			700
		]
	],
	"./Users/": [
		75700,
		[
			700
		]
	],
	"./Users/Create": [
		96862,
		[
			862
		]
	],
	"./Users/Create.jsx": [
		96862,
		[
			862
		]
	],
	"./Users/Roles": [
		17802,
		[
			802
		]
	],
	"./Users/Roles/": [
		17802,
		[
			802
		]
	],
	"./Users/Roles/Create": [
		30796,
		[
			796
		]
	],
	"./Users/Roles/Create.jsx": [
		30796,
		[
			796
		]
	],
	"./Users/Roles/Update": [
		34771,
		[
			771
		]
	],
	"./Users/Roles/Update.jsx": [
		34771,
		[
			771
		]
	],
	"./Users/Roles/index": [
		17802,
		[
			802
		]
	],
	"./Users/Roles/index.jsx": [
		17802,
		[
			802
		]
	],
	"./Users/Screens": [
		94599,
		[
			599
		]
	],
	"./Users/Screens.jsx": [
		94599,
		[
			599
		]
	],
	"./Users/Update": [
		94021,
		[
			21
		]
	],
	"./Users/Update.jsx": [
		94021,
		[
			21
		]
	],
	"./Users/index": [
		75700,
		[
			700
		]
	],
	"./Users/index.jsx": [
		75700,
		[
			700
		]
	],
	"./Users/reducer": [
		44416,
		[]
	],
	"./Users/reducer.js": [
		44416,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50629;
module.exports = webpackAsyncContext;